import './Download.css'
import React, { useEffect, useState } from 'react';
import {Table} from 'antd'
import { ColumnsType } from 'antd/lib/table';
import axios from 'axios';

const columns: ColumnsType<any> =[
    {
        title: '名称',
        dataIndex: 'name',
        render(text){
            return <a href={`${process.env.REACT_APP_DOWNLOAD_ENTRYPORT}/${text}`}>{text}</a>
        }
    },
    {
        title: '修改日期',
        dataIndex: 'mtime',
        render(text){
            return <>{new Date(text).toLocaleString()}</>;
        },
    },
    {
        title: '大小',
        dataIndex: 'size',
        render:(text)=>{
            const units= ['B','KB','MB','GB'];
            let unitsIndex = 0;
            let size:number = text;
            while(size>1024){
                size/=1024;
                ++unitsIndex;
            }
            return <>{`${size.toFixed(2)} ${units[unitsIndex]}`}</>
        }
    },
]
export function Download(props:{
    
}){
    const [dataSource, setDataSource]=useState([]);
    useEffect(()=>{
        if(!process.env.REACT_APP_DOWNLOAD_ENTRYPORT) return;
        axios.get(process.env.REACT_APP_DOWNLOAD_ENTRYPORT)
        .then(response=>{
            setDataSource(response.data);
        }).catch(console.error);
    },[])
    return  <div className='gsde-container' style={{padding:20}}> 
        <Table pagination={false} columns={columns} dataSource={dataSource} />
    </div>

} 